import { useContext } from 'react';
import { Info } from 'lucide-react';

import styles from './About.module.css';

import { NAVBAR_ICON_URL } from '@/constants';
import config from '@/config';

import { Modal } from '../modal/Modal';
import { useDialog } from '@/hooks/use-dialog';
import { useQueryClient } from '@tanstack/react-query';
import { AppContext } from '@/App.context';

export const About = ({ show, setShow }: AboutProps) => {
	const queryClient = useQueryClient();
	const { kv } = useContext(AppContext);
	const { title, version, about, buildNumber } = config.build;
	const handleClick = (e: any) => {
		switch (e.detail) {
			case 2:
				window.location.replace('/drafts');
				break;
		}
	};

	const onClickClearCache = () => {
		if (!confirm('Are you sure you want to clear the cache?')) {
			return;
		}

		kv.clear();
		if (queryClient) {
			queryClient.invalidateQueries();
			queryClient.removeQueries();
			queryClient.clear();
		}
		if ('caches' in window) {
			caches.keys().then(function (names) {
				for (let name of names) {
					caches.delete(name);
				}
			});
		}

		window.location.reload();
	};

	// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
	const v = <span onClick={handleClick}> {version}</span>;

	return (
		<Modal
			classNames={[styles['container']]}
			hasCloseBtn={true}
			isOpen={show}
			onClose={() => {
				setShow(false);
			}}
		>
			<div className={styles['about-dialog']}>
				<h3>{title}</h3>
				<h4>Version: {v}</h4>
				<h4>Build: {buildNumber}</h4>
				<h4
					onClick={onClickClearCache}
					className={styles['clear-cache']}
				>
					Clear Cache
				</h4>
				{about ? (
					<div dangerouslySetInnerHTML={{ __html: about }} />
				) : null}
			</div>
		</Modal>
	);
};

interface AboutProps {
	show: boolean;
	setShow: (value: boolean) => void;
}

export function AboutButton() {
	const { setShowDialog } = useDialog();
	const className = [styles['about'], 'tooltip down cursor-pointer'].join(
		' ',
	);

	const onClick = () => {
		setShowDialog(true);
	};

	return (
		<button
			type="button"
			className={className}
			data-text="About"
			onClick={onClick}
		>
			<Info />
		</button>
	);
}
